import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { UseFormRegisterReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface SceneMetaFieldsProps {
  register: (
    name: 'settings' | 'pointOfScene' | 'goal' | 'conflict' | 'themes' | 'changesToMake'
  ) => UseFormRegisterReturn;
}

export function SceneMetaFields({ register }: SceneMetaFieldsProps) {
  const { t } = useTranslation();

  return (
    <Grid container spacing={4}>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          {...register('settings')}
          label={t('entity_form.scenes.settings_label')}
          placeholder={t('entity_form.scenes.settings_placeholder')}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          {...register('pointOfScene')}
          label={t('entity_form.scenes.point_of_scene_label')}
          placeholder={t('entity_form.scenes.point_of_scene_placeholder')}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          {...register('goal')}
          label={t('entity_form.scenes.goal_label')}
          placeholder={t('entity_form.scenes.goal_placeholder')}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          {...register('conflict')}
          label={t('entity_form.scenes.conflict_label')}
          placeholder={t('entity_form.scenes.conflict_placeholder')}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          {...register('themes')}
          label={t('entity_form.scenes.themes_label')}
          placeholder={t('entity_form.scenes.themes_placeholder')}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          {...register('changesToMake')}
          label={t('entity_form.scenes.changes_to_make_label')}
          placeholder={t('entity_form.scenes.changes_to_make_placeholder')}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>
    </Grid>
  );
}
